// extracted by mini-css-extract-plugin
export default {"label":"TeamIconEditor-module__label--cnC34","animatedBackground":"TeamIconEditor-module__animatedBackground--KGT7q"};